<template>
	<div>
		<h2 class="subtitulo">INSTANCIAS FORMADORAS</h2>
		<!-- <h4>Catálogo de instancias formadoras</h4> -->
		<hr />
		<b-form-group label="" label-for="filterInput">
			<b-input-group>
				<b-form-input
					v-model="filter"
					type="search"
					id="filterInput"
					placeholder="BUSCAR"
				></b-form-input>
				<b-input-group-append>
					<button class = "btn bg-5" :disabled="!filter" @click="filter = ''">Limpiar</button>
				</b-input-group-append>
			</b-input-group>
		</b-form-group>
		<button class = "btn bg-2" @click="openModalInstancia()"> Nueva instancia</button>
		<div class="stCard cartaInfo">
			<b-table
				striped
				hover
				:items="instancias"
				:busy="cargando"
				:fields="fields"
				:filter="filter"
			>
				<template v-slot:table-busy>
					<div class="text-center text-danger my-2">
						<b-spinner class="align-middle"></b-spinner>
						<strong>Cargando...</strong>
					</div>
				</template>
				<template v-slot:cell(img)="data">
					<!--img
						height="auto"
						width="100px"
						:src="env_url + '/backassets/logos/' + data.item.img"
					/-->
					<img
						height="auto"
						width="100px"
						:src="'https://sifc.iea.edu.mx' + '/backassets/logos/' + data.item.img"
					/>

				</template>
				<template #cell(Detalles)="row">
					<button class = "btn bg-1" @click="row.toggleDetails">
						{{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }} Detalles
					</button>
				</template>
				<template #row-details="row">
					<b-card>
						<b-row class="mb-2">
							<b-col sm="3" class="text-sm-right"><b>Id:</b></b-col>
							<b-col>{{ row.item.institucion_formadora }}</b-col>
						</b-row>

						<b-row class="mb-2">
							<b-col sm="3" class="text-sm-right"><b>Activa:</b></b-col>
							<b-col>{{ row.item.activo_institucion_formadora }}</b-col>
						</b-row>

						<button class = "btn bg-2" size="sm" @click="row.toggleDetails"
							>Ocultar Detalles</button
						>
						<!--
						<b-button size="sm" @click="openModalInstancia(row.item)"
							>Editar</b-button
						>
						-->
					</b-card>
				</template>
			</b-table>
		</div>
		<registroInstanciaFormadoraModal></registroInstanciaFormadoraModal>
	</div>
</template>

<script>
//import axios from 'axios';
import RegistroInstanciaFormadoraModal from '../modals/registroInstanciaFormadoraModal';
import { queryIEASIS } from '../backIeasis/dbContextConexion';

export default {
	name: 'InstanciasComponent',
	components: { RegistroInstanciaFormadoraModal },
	data() {
		return {
			modalRegistroInstanciaFormadora: false,
			env_url: process.env.VUE_APP_URL,
			filter: null,
			instancias: [],
			instanciaSelected: false,
			cargando: false,
			fields: [
				{
					key: 'img',
				},
				{
					key: 'institucion_formadora',
					sortable: true,
				},
				{
					key: 'Detalles',
					sortable: true,
				},
			],
		};
	},
	mounted() {
		this.getInstancias();
	},
	methods: {
		async getInstancias() {
			this.cargando = true;
			/*
			axios
				.get(process.env.VUE_APP_URL + '/institucionesFormadoras', {
					headers: {
						Authorization: 'bearer ' + sessionStorage.getItem('token'),
					},
				})
				.then((res) => {
					console.log(res.data);
					this.instancias = res.data;
					this.cargando = false;
				});
				*/
			const query = "select *, CASE WHEN activo=1 THEN 'Activo' else 'Inactivo' END AS activo_institucion_formadora from instituciones_formadoras"
			const res = await queryIEASIS(query)
			if (res){
				console.log('res de instituciones formadoras',res);
				this.instancias = res;
				this.cargando = false;
			}
		},
		openModalInstancia(instancia = false) {
			if (instancia) {
				this.instanciaSelected = instancia;
			} else {
				this.instanciaSelected = false;
			}
			this.modalRegistroInstanciaFormadora = true;
		},
	},
};
</script>
